export class Gender {
    name: string;
    id: number;
    code: string;
}